module.exports = __webpack_public_path__ + "img/pin.8f1c9b14.svg";